import { z } from "zod";

export const RequestTagDataSchema = z.object({
    id: z.string(),
    name: z.string().nullish(),
    description: z.string().nullish(),
    icon: z.string().nullish(),
    reactIcon: z.string().nullish(),
    iconColor: z.string().nullish(),
    order: z.number().nullish(),
    parentTagId: z.string().nullish(),
});

export type RequestTagData = z.infer<typeof RequestTagDataSchema>;